import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, ArrowUpRight } from "lucide-react";
import { company, navLinks, footerLinks } from "../mock";

export default function Footer() {
  return (
    <footer className="bg-ink text-white pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 pb-12 border-b border-white/10">
          {/* Brand */}
          <div className="md:col-span-1">
            <img src={company.logo} alt={company.name} className="h-16 w-auto object-contain bg-white rounded-xl p-2" />
            <p className="mt-4 text-sm text-white/60 leading-relaxed">
              Premium vending machines, installed and serviced free for qualifying workplaces. {company.tagline}
            </p>
          </div>

          {/* Explore */}
          <div>
            <h4 className="font-display text-gold uppercase tracking-widest text-sm mb-4">Explore</h4>
            <ul className="space-y-2.5">
              {navLinks.map((l) => (
                <li key={l.to}>
                  <Link to={l.to} className="text-sm text-white/70 hover:text-gold transition-colors">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="font-display text-gold uppercase tracking-widest text-sm mb-4">Legal</h4>
            <ul className="space-y-2.5">
              {footerLinks.map((l) => (
                <li key={l.to}>
                  <Link to={l.to} className="text-sm text-white/70 hover:text-gold transition-colors">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-display text-gold uppercase tracking-widest text-sm mb-4">Get in touch</h4>
            <ul className="space-y-3 text-sm text-white/70">
              <li>
                <a href={company.phoneHref} className="flex items-center gap-2 hover:text-gold">
                  <Phone size={16} className="text-gold" /> {company.phone}
                </a>
              </li>
              <li>
                <a href={`mailto:${company.email}`} className="flex items-center gap-2 hover:text-gold">
                  <Mail size={16} className="text-gold" /> {company.email}
                </a>
              </li>
              <li className="flex items-start gap-2">
                <MapPin size={16} className="text-gold mt-0.5 shrink-0" /> {company.serviceArea}
              </li>
            </ul>
            <Link
              to="/contact"
              className="mt-5 inline-flex items-center gap-1.5 text-sm font-semibold text-gold hover:text-gold-light"
            >
              Book a free site visit <ArrowUpRight size={16} />
            </Link>
          </div>
        </div>

        <div className="pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-white/50">
            © {new Date().getFullYear()} {company.name}. All rights reserved.
          </p>
          <p className="text-xs text-white/50">{company.tagline}</p>
        </div>
      </div>
    </footer>
  );
}
